import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/devices/iPhone-14Pro-Portrait.png'


const _withScopeId = n => (_pushScopeId("data-v-286931e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "frame",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "screenshot",
        src: _ctx.img
      }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}